import { BASE_ENDPOINT } from "../../../endpoint";

export const updateUserByIdService = async (id: string, payload: any, token: string) => {
    try {
        const response = await fetch(`${BASE_ENDPOINT}/usermanagement/user/update/${id}`, {
            method: 'PATCH',
            headers: {
                'Authorization': `Bearer ${token}`,
            },
            body: payload
        });
        const res = await response.json();
        if (!response.ok) {
            console.error('Error:', res);
            throw new Error(res.message);
        }
        return res;
    } catch (error) {
        console.error('API fetch error:', error);
        throw error;
    }
};
